import React, { useState, useEffect } from "react";

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  useEffect(() => {
    // Vérifie s'il existe déjà un choix enregistré
    const consent = localStorage.getItem("quantum_cookie_consent");
    if (!consent) {
      // Si aucun choix, on affiche la bannière après un court délai pour l'effet visuel
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (choice) => {
    setIsAnimatingOut(true);
    // On attend la fin de l'animation de sortie (300ms) pour démonter le composant
    setTimeout(() => {
      localStorage.setItem("quantum_cookie_consent", choice);
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Injection des animations CSS spécifiques */}
      <style>{`
        @keyframes cookieSlideUp {
          from {
            transform: translateY(50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        @keyframes cookieFadeOut {
          from {
            transform: translateY(0);
            opacity: 1;
          }
          to {
            transform: translateY(30px);
            opacity: 0;
          }
        }
        .cookie-banner-container {
          animation: cookieSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .cookie-banner-container.exit {
          animation: cookieFadeOut 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .cookie-btn-accept:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0, 255, 148, 0.4) !important;
          background: #00ff94 !important;
          color: #000 !important;
        }
        .cookie-btn-decline:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 255, 255, 0.1) !important;
          border-color: #fff !important;
          color: #fff !important;
        }
      `}</style>

      <div
        className={`cookie-banner-container ${isAnimatingOut ? "exit" : ""}`}
        style={{
          position: "fixed",
          bottom: "24px",
          left: "24px",
          right: "24px",
          maxWidth: "600px",
          margin: "0 auto",
          zIndex: 99999,
          background: "rgba(10, 15, 30, 0.82)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border: "1px solid rgba(0, 255, 148, 0.25)",
          borderRadius: "16px",
          padding: "20px 24px",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.6), 0 0 30px rgba(0, 255, 148, 0.05)",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          fontFamily: "'Inter', system-ui, sans-serif"
        }}
      >
        {/* En-tête */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ fontSize: "1.3rem" }}>🍪</span>
          <h4
            style={{
              margin: 0,
              fontSize: "1rem",
              fontWeight: "bold",
              color: "#00ff94",
              letterSpacing: "1px",
              textTransform: "uppercase"
            }}
          >
            Respect de la vie privée & Sécurité
          </h4>
        </div>

        {/* Corps du message */}
        <p
          style={{
            margin: 0,
            fontSize: "0.85rem",
            lineHeight: "1.6",
            color: "#ccc"
          }}
        >
          Nous utilisons uniquement des cookies techniques nécessaires à la sécurité et à la gestion 
          de vos sessions cryptographiques. Aucun traceur publicitaire n'est déposé.
        </p>

        {/* Boutons d'actions */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginTop: "4px"
          }}
        >
          <button
            className="cookie-btn-decline"
            onClick={() => handleConsent("declined")}
            style={{
              background: "transparent",
              border: "1px solid #444",
              color: "#aaa",
              padding: "8px 18px",
              borderRadius: "8px",
              fontSize: "0.85rem",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease"
            }}
          >
            Refuser
          </button>
          <button
            className="cookie-btn-accept"
            onClick={() => handleConsent("accepted")}
            style={{
              background: "rgba(0, 255, 148, 0.15)",
              border: "1px solid #00ff94",
              color: "#00ff94",
              padding: "8px 24px",
              borderRadius: "8px",
              fontSize: "0.85rem",
              fontWeight: "700",
              cursor: "pointer",
              transition: "all 0.2s ease"
            }}
          >
            Tout Accepter
          </button>
        </div>
      </div>
    </>
  );
}
